<template lang="pug">
  .page
    section
      b-container
        h1 404
        h4 Page not found
        p This page is no longer available
</template>

<script>

export default {
  name: 'RegisterOk',
  components: {
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/NotFound.vue